import { render, staticRenderFns } from "./LeadsByStatus.vue?vue&type=template&id=8c0b5d7a&scoped=true&"
import script from "./LeadsByStatus.vue?vue&type=script&lang=js&"
export * from "./LeadsByStatus.vue?vue&type=script&lang=js&"
import style0 from "./LeadsByStatus.vue?vue&type=style&index=0&id=8c0b5d7a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c0b5d7a",
  null
  
)

export default component.exports